<script>
    import Icon from "./Icon.svelte";
    import moon from "../icons/moon.svg";
    import sun from "../icons/sun.svg";

	let darkMode = false;
	function toggle() {
      darkMode = !darkMode;
  }

  function toggleClass(node, {activate, className}) {
    // The node has been mounted in the DOM
    activate ? node.classList.add(className) : node.classList.remove(className);
    return {
      update({activate, className}) {
        activate ? node.classList.add(className) : node.classList.remove(className);
      }
    };
  }

</script>

<svelte:body use:toggleClass="{{activate: darkMode, className: 'dark'}}"/>

<button on:click={toggle}>
	{#if darkMode }
	<Icon data={sun} />
	{:else}
    <Icon data={moon} />
	{/if}
</button>

<style>
	button {
		background: var(--bg-color);
        border: none;
		color: var(--text-color);
		padding: 10px 15px;
	}
	
	button:active {
		background: inherit;
	}
</style>